import "./App.css";
import "antd/dist/antd.css";

import { Layout, Breadcrumb, Typography, Result } from "antd";

const { Header, Content, Footer } = Layout;
const { Text } = Typography;

enum BeianType {
  Beian720 = 720,
  Beian721 = 721,
  Unknwon = 0,
}

function getBeianType(): BeianType {
  switch (window.location.host.replace(/^www\./i, "")) {
    case "ai-io.xyz":
    case "webnext.xyz":
    case "tonext.xyz":
      return BeianType.Beian720;
    case "jiadianjiadian.com":
    case "chalecha.com":
    case "awesometoolkit.com":
    case "cuolemei.com":
    case "chayufa.com":
      return BeianType.Beian721;
    default:
      return BeianType.Unknwon;
  }
}

function getSiteName(): string {
  switch (getBeianType()) {
    case BeianType.Beian720:
      return "我的技能树";
    case BeianType.Beian721:
      return "我的技能分享";
    default:
      return "Test";
  }
}

function AppFooter() {
  switch (getBeianType()) {
    case BeianType.Beian720:
      return (
        <Footer id="footer" style={{ textAlign: "center" }}>
          <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">
            鄂ICP备17027592号
          </a>
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42010602000720"
            rel="noreferrer"
            target="_blank"
          >
            <img src="./gongan.png" alt="备案logo" /> 鄂公网安备
            42010602000720号
          </a>
        </Footer>
      );
    case BeianType.Beian721:
      return (
        <Footer id="footer" style={{ textAlign: "center" }}>
          <a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">
            鄂ICP备17027592号
          </a>
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42010602000721"
            rel="noreferrer"
            target="_blank"
          >
            <img src="./gongan.png" alt="备案logo" /> 鄂公网安备
            42010602000721号
          </a>
        </Footer>
      );
    default:
      return (
        <Footer id="footer" style={{ textAlign: "center" }}>
          ...
        </Footer>
      );
  }
}

function App() {
  const siteName = getSiteName();
  document.title = siteName;

  return (
    <Layout className="layout">
      <Header id="header">
        <div className="logo" />
        <Text strong>{siteName}</Text>
      </Header>
      <Content style={{ padding: "0 50px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}></Breadcrumb>

        <div className="site-layout-content">
          <Result status="warning" title="建设中" />
        </div>
      </Content>
      <AppFooter />
    </Layout>
  );
}

export default App;
